import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import generalStyles from './style/general.css';
import stateStyles from './style/state.css';
import typeStyles from './style/type.css';

const cx = classNames.bind({
  ...generalStyles,
  ...stateStyles,
  ...typeStyles,
});

/**
 * There are a variety of different link styles available to be used across the
 * product, marketing site and the blog. The optional `type` prop defines the
 * link style and the optional `hasUnderline` style adds a underline to each link.
 */
export default function Link({
  alt,
  block,
  children,
  hasUnderline,
  id,
  isActive,
  isDisabled,
  onClick,
  target,
  title,
  type,
  url,
  // data-bypass required in pie for external links
  'data-bypass': dataBypass,
}) {
  const linkClasses = cx('link', {
    [`${type}-isActive`]: isActive && !isDisabled,
    [`${type}-hasUnderline`]: hasUnderline,
    [`${type}-isDisabled`]: isDisabled,
    [type]: !isActive && !isDisabled,
    'display-block': block,
    'display-inlineBlock': !block,
    isDisabled,
  });

  const linkProps = {
    alt,
    className: linkClasses,
    id,
    onClick,
    title,
  };
  if (dataBypass) {
    linkProps['data-bypass'] = true;
  }

  if (url) {
    return (
      <a {...linkProps} target={target} href={url}>
        {children}
      </a>
    );
  }
  return <span {...linkProps}>{children}</span>;
}

Link.propTypes = {
  alt: PropTypes.string,
  block: PropTypes.bool,
  children: PropTypes.node,
  hasUnderline: PropTypes.bool,
  id: PropTypes.string,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  target: PropTypes.oneOf(['_blank', '_parent', '_self', '_top']),
  title: PropTypes.string,
  type: PropTypes.oneOf(Object.keys(typeStyles)).isRequired,
  url: PropTypes.string,
  'data-bypass': PropTypes.bool,
};

Link.defaultProps = {
  block: false,
  hasUnderline: false,
  isActive: false,
  type: 'light',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-link/Link/index.js